import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  PostApiStripepaymentgatewaySaveCardDetailMutationRequest,
  PostApiStripepaymentgatewaySaveCardDetailMutationResponse,
  PostApiStripepaymentgatewaySaveCardDetail401,
  PostApiStripepaymentgatewaySaveCardDetail403,
} from "../../../types/PostApiStripepaymentgatewaySaveCardDetail";

export function getPostApiStripepaymentgatewaySaveCardDetailUrl() {
  return `/api/StripePaymentGateway/save-card-detail` as const;
}

/**
 * {@link /api/StripePaymentGateway/save-card-detail}
 */
export async function postApiStripepaymentgatewaySaveCardDetail(
  data?: PostApiStripepaymentgatewaySaveCardDetailMutationRequest,
  config: Partial<
    RequestConfig<PostApiStripepaymentgatewaySaveCardDetailMutationRequest>
  > & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    PostApiStripepaymentgatewaySaveCardDetailMutationResponse,
    ResponseErrorConfig<
      | PostApiStripepaymentgatewaySaveCardDetail401
      | PostApiStripepaymentgatewaySaveCardDetail403
    >,
    PostApiStripepaymentgatewaySaveCardDetailMutationRequest
  >({
    method: "POST",
    url: getPostApiStripepaymentgatewaySaveCardDetailUrl().toString(),
    data,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}
